import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { generateQuery } from 'Src/ng2/store/effects/projections/student-groupings';
import { ApiService } from '../../../../shared/services/api-service/api-service';
import { IFocus } from './../../academic-list-v2/academic-list-data/academic-data.service';

@Injectable()
export class StudentsListDataService {
  private fociCache$: Observable<any> = null;

  constructor(public apiService: ApiService) {}

  getStudentsListFocusData$(schoolId: string, focusKey?: string): Observable<{ data: { StudentsFocus: IFocus[] } }> {
    const payload = this.getStudentsListFocusQuery(schoolId, focusKey);
    if (!focusKey) {
      if (!this.fociCache$) this.fociCache$ = this.apiService.getStudentsGraphQL(payload).pipe(shareReplay(1));
      return this.fociCache$;
    } else {
      return this.apiService.getStudentsGraphQL(payload);
    }
  }

  getStudentsListGroupingData$(payload: {
    schoolId: string;
    filterKeys: string[];
    groupingKey: string;
    columns: string[];
  }) {
    // only want active students, so we append this filter behind the scenes
    payload.filterKeys.push('ACTIVE_ONLY');

    const query = generateQuery({ payload });
    return this.apiService.getStudentsGraphQL({ query, fetchPolicy: 'no-cache' });
  }

  getStudentsListFocusQuery(schoolId: string, focusKey?: string) {
    const payload = focusKey ? `schoolId:"${schoolId}", focusKey:"${focusKey}"` : `schoolId:"${schoolId}"`;

    const query = `{
      StudentsFocus(${payload}) {
        graphQlKey
        label
        isDefault
        category
        categoryOrder
        fociOrder
        filters {
          label
          filterOptions {
            graphQlKey
            label
            isDefault
          }
        }
        groupings {
          graphQlKey
          label
          requiresWildcard
          columns {
            graphQlKey
            label
            requiresWildcard
            columnDataFormat
            cellConfig
            cellTooltip
            headerTooltip {
              ...on SimpleTooltip {
                simpleContent
              }
              ...on TableTooltip {
                tableContent {
                  headers
                  rowData
                }
              }
            }
          }
        }
      }
    }`;
    return { query, fetchPolicy: 'no-cache' };
  }

  clearFociCache(): void {
    this.fociCache$ = null;
  }
}
